import Vue from 'vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"

import store from '@/store'
/**
 * 单点登录
 */
const init = (callback) => {
  if (window._CONFIG['sso']) {
    console.log("-------单点登录开始-------");
    let token = getUrlParam("token")
    let sevice = window.location.href;
    if (!token) {
      token =  Vue.ls.get(ACCESS_TOKEN);
    }
    if(token){
      validateSt(token,callback);
    }else{
      let serviceUrl = encodeURIComponent(sevice);
      window.location.href = (window._CONFIG['casPrefixUrl']  ) + "?redirect="+ serviceUrl;
    }
    // if (token) {
    //   loginSuccess(callback);
    // } else {
    //   token = getUrlParam("token");
    //   if (token) {
    //     validateSt(token, sevice, callback);
    //   } else {
    //     let serviceUrl = encodeURIComponent(sevice);
    //     window.location.href = (window._CONFIG['casPrefixUrl']  ) + "?redirect="+ serviceUrl;
    //   }
    // }
    console.log("-------单点登录结束-------");
  }else{
    callback && callback()
  }
};
const SSO = {
  init: init
};

function getUrlParam(paraName) {
  let url = document.location.toString();
  let arrObj = url.split("?");

  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split("&");
    let arr;

    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");

      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  }
  else {
    return "";
  }
}

function validateSt(token,callback){
  store.dispatch('ValidateLogin',token).then(res => {
    //this.departConfirm(res)
    if(res.success){
      loginSuccess(callback);
    }else{
      Vue.ls.remove(ACCESS_TOKEN)
      // Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
      // Vue.ls.remove(CACHE_INCLUDED_ROUTES)
      const paths = window.location.href.split("?")
      let sevice = paths[0];
      let serviceUrl = encodeURIComponent(sevice);
      // window.location.href = window._CONFIG['casPrefixUrl'] + "?redirect="+ serviceUrl;
      window.location.href = window._CONFIG['casPrefixUrlLogout']+"?redirect=" + serviceUrl
    }
  }).catch((err) => {
    console.log(err);
    //that.requestFailed(err);
  });
}

function loginSuccess (callback) {
  callback();
}
export default SSO;